/**
 * InfinitSales - Aviso de sessão expirada (flag REACT_APP_SSE_EXP_CHECK)
 *
 * O AuthContext detecta o JWT vencido (pelo sseService ou por timer no `exp`)
 * e encerra a sessão; este card no canto (mesmo SwipeToast do sino) avisa o
 * usuário em vez de ele só "cair" no login.
 *
 * Montado globalmente no App.js, FORA das rotas e fora do NotificationsProvider
 * de propósito: a fila de toasts do sino é zerada quando `isAuthenticated`
 * cai, e este aviso precisa sobreviver exatamente a esse momento.
 *
 * Sessão normal: navega para /login (mesmo gesto do botão Sair no NavSidebar);
 * o toast fica visível na tela de login e some sozinho.
 * Sessão delegada: o AuthContext já agendou endDelegation + reload para
 * /empresa (caminho do api.js); aqui só avisamos.
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import SwipeToast from './SwipeToast';
import { useAuth } from '../../contexts/AuthContext';

const AUTO_DISMISS_MS = 8_000;

const SessionExpiredToast = () => {
  const { sessionExpired, dismissSessionExpired } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionExpired) return undefined;
    if (!sessionExpired.delegated) {
      navigate('/login', { replace: true });
    }
    const t = window.setTimeout(dismissSessionExpired, AUTO_DISMISS_MS);
    return () => window.clearTimeout(t);
  }, [sessionExpired, navigate, dismissSessionExpired]);

  if (!sessionExpired) return null;

  return (
    <SwipeToast
      key={sessionExpired.at}
      isOpen
      icon={<LogOut size={18} />}
      title="Sua sessão expirou"
      description={
        sessionExpired.delegated
          ? 'Voltando para a tela de workspaces. Se pedir, entre novamente.'
          : 'Entre novamente para continuar.'
      }
      onDismiss={dismissSessionExpired}
    />
  );
};

export default SessionExpiredToast;
